var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chart)?_c('pie-chart',{attrs:{"data":_vm.chart.data,"donut":true,"legend":_vm.showLegend ? _vm.posLegend : null,"colors":_vm.chart.colors}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }